module.exports = __webpack_public_path__ + "static/dentures_a-eb49b9c2a71b2a1f2af8b5008b965c8d.jpg";